import React from 'react';
import { useTranslation } from 'react-i18next';
import { Values } from '@lib/interfaces/form';
import { GraphQLFormattedError } from 'graphql';
import Form from '@lib/components/ReactHookForm/FormContainer';
import replaceNullsWithUndefined from '@lib/utils/replaceNullsWithUndefined';
import FieldNames from '@lib/enums/fieldNames/interventionCategoryFieldNames';
import getCategoryFormFields from './utils/getCategoryFormFields';
import CategoryFormActions from './CategoryFormActions';

interface Props {
  defaultValues?: Values;
  graphQLErrors?: readonly GraphQLFormattedError[];
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: Values) => void;
}

const emptyDefaultValues = {
  [FieldNames.Color]: null,
  [FieldNames.Id]: null,
  [FieldNames.Name]: null,
  [FieldNames.Description]: null,
};

function CategoryForm(props: Props) {
  const { defaultValues, graphQLErrors, loading, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const isEditForm = !!defaultValues?.id;
  const fields = getCategoryFormFields({
    t,
  });

  return (
    <Form
      defaultValues={
        defaultValues
          ? replaceNullsWithUndefined(defaultValues)
          : emptyDefaultValues
      }
      onSubmit={onSubmit}
      fields={fields}
      actionsComponent={CategoryFormActions}
      actionsComponentProps={{
        isEditForm,
        loading,
        onCancel,
      }}
      graphQLErrors={graphQLErrors}
      loading={loading}
    />
  );
}

export default CategoryForm;
